import axios from "./axios";
import { entityModule } from '../revampPages/EventInfo/config/constants';

const API_URL = axios.defaults.baseURL;
const BASE_URL = "/event/";
const otherUrl = "/entity/"

export const getEventEntity = (eventID, entityNo) => {
    return axios.get(
        API_URL + BASE_URL + eventID + otherUrl + entityNo
    );
};

export const getEntityWithEntityId = (eventID, entityNo, entityId) => {
    return axios.get(
        API_URL + BASE_URL + eventID + otherUrl + `${entityNo}/` + entityId
    );
}

export const addEventEntity = (eventID, entityNo, payload, exhibitor_portal_url) => {
    const baseUrl = `${API_URL}${BASE_URL}${eventID}${otherUrl}${entityNo}`;

    if (exhibitor_portal_url && entityNo === entityModule.EXHIBITOR) {
        const encodedUrl = encodeURIComponent(exhibitor_portal_url);
        return axios.post(`${baseUrl}?exhibitor_portal_url=${encodedUrl}`, payload);
    }

    return axios.post(baseUrl, payload);
};


export const editEventEntity = (eventID, entityNo, entityID, payload, exhibitor_portal_url) => {
    const baseUrl = `${API_URL}${BASE_URL}${eventID}${otherUrl}${entityNo}/${entityID}`;
    if (exhibitor_portal_url && entityNo ===
        entityModule.EXHIBITOR) {
        const encodedUrl = encodeURIComponent(exhibitor_portal_url);
        return axios.put(`${baseUrl}?exhibitor_portal_url=${encodedUrl}`, payload);
    }
    return axios.put(baseUrl, payload);
};

export const deleteEventEntity = (eventID, entityNo, entityID) => {
    return axios.delete(
        API_URL + BASE_URL + eventID + otherUrl + `${entityNo}/` + entityID
    );
};

export const reorderEventEntity = (eventID, entityNo, payload) => {
    return axios.put(
        API_URL + BASE_URL + eventID + otherUrl + `${entityNo}/` + 'reorder', payload
    );
};

